import {Leasings} from "../../../../../server/src/base/entities/leasing/Leasings";
import {LeasingType} from "../../../../../server/src/base/entities/leasing/LeasingType";
import {Vans} from "../../../../../server/src/base/entities/leasing/Vans";
import {Van} from "../../../../../server/src/base/entities/leasing/Van";
import {Leasing} from "../../../../../server/src/base/entities/leasing/Leasing";
import {Reservation} from "../../../../../server/src/base/entities/leasing/calendar/Reservation";
import {Slot} from "../../../../../server/src/base/entities/leasing/calendar/Slot";
import {RemovedSlots} from "../../../../../server/src/base/entities/leasing/unaivailability/RemovedSlots";
import {RemovedSlot} from "../../../../../server/src/base/entities/leasing/unaivailability/RemovedSlot";

export abstract class IVanService {
    public abstract Leasings():Promise<Leasings>;
    public abstract Get(id:string):Promise<Van>;
    public abstract Add(van:Van):Promise<void>;
    public abstract Remove(vanId:string):Promise<void>;
    public abstract Enable(vanId:string):Promise<void>;
    public abstract Disable(vanId:string):Promise<void>;
    public abstract Vans(type:LeasingType):Promise<Vans>;
}

export class FakeVanService implements IVanService{
    public Leasings(): Promise<Leasings> {
        let leasingList:Array<Leasing> = [];
        leasingList.push(this.CreateLeasing(LeasingType.MasterFourgonL2H2, "Master fourgon L2 H2"));
        leasingList.push(this.CreateLeasing(LeasingType.TrafficFourgonL2H1, "Master fourgon L2 H1"));
        leasingList.push(this.CreateLeasing(LeasingType.MasterCaisseAlu, "Master caisse Alu"));
        leasingList.push(this.CreateLeasing(LeasingType.TrafficMinibusL2H1, "Master minibus L2 H1"));
        leasingList.push(this.CreateLeasing(LeasingType.MasterMinibusL2H2, "Master minibus L2 H2"));
        leasingList.push(this.CreateLeasing(LeasingType.TrafficSpaceClassL2H1, "Trafic space class L2 H2"));
        return Promise.resolve(new Leasings(leasingList));
    }

    public Get(id: string): Promise<Van> {
        return Promise.resolve(new Van().AsFake());
    }

    public Add(van:Van): Promise<void> {
        return Promise.resolve();
    }

    public Remove(vanId: string): Promise<void> {
        return Promise.resolve();
    }

    public Enable(vanId: string): Promise<void> {
        return Promise.resolve();
    }

    public Disable(vanId: string): Promise<void> {
        return Promise.resolve();
    }

    public Vans(type: LeasingType): Promise<Vans> {
        let vanList:Array<Van> = [];
        for(let i = 0 ; i < 3 ; ++i){
            let van:Van = new Van().AsFake();
            van.calendar.reservations = van.calendar.reservations.concat(this.CreateRandomReservationsInCurrentMonth());
            van.unavailability.removedSlots = this.CreateRandomUnavailabilitiesInCurrentMonth();
            van.type = type;
            van.leasing = this.CreateLeasing(LeasingType.MasterFourgonL2H2, "Master fourgon L2 H2");
            vanList.push(van);
        }
        return Promise.resolve(new Vans(vanList));
    }

    private CreateRandomReservationsInCurrentMonth():Array<Reservation>{
        let reservations:Array<Reservation> = [];

        for(let i = 0 ; i < Math.floor(Math.random() * 15) + 5  ; ++i){
            let date:Date = new Date();
            date.setDate(Math.floor(Math.random() * 25) + 1);
            let reservation:Reservation = new Reservation();
            reservation.slot = new Slot(date);
            reservations.push(reservation);
        }
        return reservations;
    }

    private CreateRandomUnavailabilitiesInCurrentMonth():RemovedSlots{
        let removedSlots:Array<RemovedSlot> = [];

        for(let i = 0 ; i < Math.floor(Math.random() * 15) + 5  ; ++i){
            let date:Date = new Date();
            date.setDate(Math.floor(Math.random() * 25) + 1);
            let removedSlot:RemovedSlot = new RemovedSlot();
            removedSlot.slot = new Slot(date);
            removedSlots.push(removedSlot);
        }
        return new RemovedSlots(removedSlots);
    }

    private CreateLeasing(type:LeasingType, name:string){
        let leasing:Leasing = new Leasing().AsFake();
        leasing.type = type;
        leasing.name = name;
        leasing.picture = "http://localhost:4200/assets/img/leasing/" + LeasingType[type] + ".jpg";
        return leasing;
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/domain/leasing/IVanService.ts